import { render, staticRenderFns } from "./CmgRecentAndFavoriteOrders.vue?vue&type=template&id=3b625deb&scoped=true&lang=pug&"
import script from "./cmg-recent-and-favorite-orders.ts?vue&type=script&lang=ts&"
export * from "./cmg-recent-and-favorite-orders.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRecentAndFavoriteOrders.vue?vue&type=style&index=0&id=3b625deb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b625deb",
  null
  
)

export default component.exports